import Vue from 'vue';
import Router from 'vue-router';
import routes from "./routes";
import sprintStatus from "../../views/sprintStatus";
import tickets from "../../views/tickets";
import accidents from "../../views/accidents";

Vue.use(Router);


let router = new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    linkActiveClass: 'active',
    linkExactActiveClass: 'exact-active',
    scrollBehavior() {
        return {x: 0, y: 0};
    },
    routes: [
        {
            path: '/',
            redirect: '/sprint',
        },
        {
            path: '/tickets',
            name: routes.TICKETS,
            component: tickets
        },
        {
            path: '/sprint',
            name: routes.SPRINT,
            component: sprintStatus,
        },
        {
            path: '/accidents',
            name: routes.ACCIDENTS,
            component: accidents,
        },
    ],

});
 



export default router;
